// src/context/UserContext.js
import { getMyProfileDetails } from "api/authService";
import { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading,setLoading]=useState(false)
  const [wasLoggedIn, setWasLoggedIn] = useState(false);
  const [followTab, setFollowTab] = useState("Followers");
  const [showFollowers, setShowFollowers] = useState(false);
  
useEffect(() => {
  if (user) {
    setWasLoggedIn(true);
  }
}, [user]);

  // Load user from localStorage if available
  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser && authUser !== "undefined") {
      // Fetch user profile if needed here
      setUser(JSON.parse(authUser)); // or full user data
    }
  }, []);

  const login = (userData, token) => {
    localStorage.setItem("authToken", token);
    setUser(userData);
    localStorage.setItem("authUser", JSON.stringify(userData));
  };
  const setUpdateUser = (value) => {
    setUser((prev) => ({ ...prev, ...value }));
  };
  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    localStorage.clear();
    setUser(null);
    setWasLoggedIn(true);
    setTimeout(() => {
      setWasLoggedIn(false);
    }, 500);
  };
  const refetchProfile = async () => {
    try {
      setLoading(true)
      const res = await getMyProfileDetails();
      if (res.success) {
          const user = res.body;
          // console.log('fetching', user)
          localStorage.setItem("authUser", JSON.stringify(user));
          setUser({ ...res.body }); 
      
      
      }
    } catch (err) {
      console.error("Failed to fetch profile:", err);
    } finally {
      setLoading(false);
    }
  };
  const value = {
    user,
    isLoggedIn: !!user,
    login,
    logout,
    setUpdateUser,
    loading,
    refetchProfile,
    wasLoggedIn,
    followTab,
    setFollowTab,
    showFollowers,
    setShowFollowers,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useAuth = () => useContext(UserContext);
